export const ExternalAccountEndpoints = {
    linkAccount: 'link-accounts',
    loginAccount: 'login-external',
}
